enum PublicNavigationLocations {
  HOME = "HOME",
  FIRST_LOGIN_RESET_PASSWORD = "FIRST_LOGIN_RESET_PASSWORD",
  CORPORATE_FIRST_LOGIN = "CORPORATE_FIRST_LOGIN",
}

export default PublicNavigationLocations;